/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskExclusionsListBuiltinExclusions } from "../funcs/riskExclusionsListBuiltinExclusions.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListBuiltinExclusionsResult } from "../models/components/listbuiltinexclusionsresult.js";
import {
  ListBuiltinExclusionsRequest,
  ListBuiltinExclusionsSecurity,
} from "../models/operations/listbuiltinexclusions.js";
import { unwrapAsync } from "../types/fp.js";
export type BuiltinExclusionsQueryData = ListBuiltinExclusionsResult;

export function prefetchBuiltinExclusions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListBuiltinExclusionsRequest | undefined,
  security?: ListBuiltinExclusionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildBuiltinExclusionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildBuiltinExclusionsQuery(
  client$: GramCore,
  request?: ListBuiltinExclusionsRequest | undefined,
  security?: ListBuiltinExclusionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<BuiltinExclusionsQueryData>;
} {
  return {
    queryKey: queryKeyBuiltinExclusions({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function builtinExclusionsQueryFn(
      ctx,
    ): Promise<BuiltinExclusionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskExclusionsListBuiltinExclusions(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyBuiltinExclusions(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "exclusions", "listBuiltinExclusions", parameters];
}
